import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import animate from "animate.css";
import schema from "async-validator";
import dialog from "./utils/dialog";
import $scroll from "@utils/loading";
import cookie from "@utils/store/cookie";

import "@styles/vant-variables.less";
import "@assets/iconfont/iconfont";
import "@assets/iconfont/iconfont.css";
import "@assets/js/media_750";
import "vue-ydui/dist/ydui.base.css";
import "@assets/css/base.css";
import "@assets/css/reset.css";
import "@assets/css/style.css";
import { isWeixin, parseQuery } from "@utils";

Vue.use(animate);
Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== "production";
Vue.prototype.$validator = function (rule) {
  return new schema(rule);
};
Vue.prototype.$scroll = $scroll;
Vue.prototype.$dialog = dialog;

const CACHE_KEY = "clear_0.0.1";

if (!cookie.has(CACHE_KEY)) {
  cookie.clearAll();
  cookie.set(CACHE_KEY, 1);
}

let cookieName = "VCONSOLE";
let query = parseQuery();
let urlSpread = query["spread"];
let urlAid = query["aid"];

let vconsole = query[cookieName.toLowerCase()];
let md5Open = "b14d1e9baeced9bb7525ab19ee35f2d2"; //开启 vconsole 调试模式的密钥
let md5Close = "3dca2162c4e101b7656793a1af20295c"; //关闭 vconsole 调试模式的密钥

if (urlSpread !== undefined) {
  var spread = cookie.get("spread");
  urlSpread = parseInt(urlSpread);
  if (!Number.isNaN(urlSpread) && spread !== urlSpread) {
    cookie.set("spread", urlSpread || 0);
  } else if (spread === 0 || typeof spread !== "number") {
    cookie.set("spread", urlSpread || 0);
  }
}
if (urlAid !== undefined) {
  var aid = cookie.get("aid");
  urlAid = parseInt(urlAid);
  if (!Number.isNaN(urlAid) && spread !== urlAid) {
    cookie.set("aid", urlAid || 0);
  } else if (aid === 0 || typeof aid !== "number") {
    cookie.set("aid", urlAid || 0);
  }
}

if (vconsole !== undefined) {
  if (vconsole === md5Close && cookie.has(cookieName))
    cookie.remove(cookieName);
} else vconsole = cookie.get(cookieName);

if (vconsole !== undefined && vconsole === md5Open) {
  cookie.set(cookieName, md5Open, 3600);
  const module = () => import("vconsole");
  module().then((Module) => {
    new Module.default();
  });
}

const _isWechat = isWeixin();
if (_isWechat) {
  console.info("do main weichat");
  const module = () => import("@libs/wechat");
  // 不再启动时立即初始化 JSSDK（会按当前 URL 请求一次签名），
  // 由 oAuth/toAuth 及分享、支付等功能按需初始化
  module().then((Module) => {
    Module.oAuth();
    console.info("do main weichat end.......");
  });
}

const $vm = new Vue({
  router,
  store,
  render: (h) => h(App),
});

setTimeout(() => {
  $vm.$mount("#app");
}, 300);
